import { NgModule } from '@angular/core';
import { AriaDirective } from './aria.directive';
import { AriaHiddenDirective } from './aria-hidden.directive';
import { TabIndexDirective } from './tab-index.directive';



@NgModule({
  declarations: [AriaDirective, AriaHiddenDirective, TabIndexDirective],
  imports: [
  ],
  exports : [
    AriaDirective,
    AriaHiddenDirective,
    TabIndexDirective
  ]
})
export class AccessabilityModule { }
